import { Actions, Events } from "@Context/common/general/context";
import useGlobalContext from "@hooks/common/general/use-global-context";
import { useRef } from "react";

const useExitBootcamp = () => {
  const { dispatch } = useGlobalContext();
  const isCompletingRef = useRef(false);

  return () => {
    if (isCompletingRef.current) return;
    isCompletingRef.current = true;

    dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: { user: { inBootcamp: false } },
      disableLoaders: true,
      onSuccess: () => Events.app.navigate.emit({ path: "/home", reset: true }),
    });
  };
};

export default useExitBootcamp;
